"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enterCode = exports.buttonWrapperPrefix = exports.iconSize = exports.crossIconRole = exports.modalPopupId = exports.modalPopupRole = exports.classes = void 0;
var classes = {
  overlayContainer: 'modal-overlay-container',
  modalContainer: 'modal-container',
  modalStrap: 'modal-strap',
  headingContainer: 'heading-container',
  titleContainer: 'title-container',
  buttonsContainer: 'buttons-container',
  buttonWrapper: 'button-wrapper',
  iconContainer: 'icon-container',
  icon: 'icon',
  modalChildren: 'modal-children',
  modalChildrenContainer: 'modal-children-container',
  contentSeparator: 'content-separator'
};
exports.classes = classes;
var modalPopupRole = 'modal-popup';
exports.modalPopupRole = modalPopupRole;
var modalPopupId = 'modal-popup';
exports.modalPopupId = modalPopupId;
var crossIconRole = 'cross-icon';
exports.crossIconRole = crossIconRole;
var iconSize = 24;
exports.iconSize = iconSize;
var buttonWrapperPrefix = 'button-';
exports.buttonWrapperPrefix = buttonWrapperPrefix;
var enterCode = 'Enter';
exports.enterCode = enterCode;